module.exports = __webpack_public_path__ + "static/media/12b.1e401f4a.svg";